module.exports = __webpack_public_path__ + "assets/img/paste.3008832f.png";